define([
  "jquery",
  "backbone",
  "moment",
  "../../global/router",
  "../../global/util",
  "../../global/templateEngine",
  "./template/view.hbs",
  "./template/select.hbs",
  "./template/status.hbs",
  "tlite",
  "../../lib/datepicker"
], (
  $,
  Backbone,
  moment,
  router,
  util,
  tplEngine,
  tpl,
  tplSelectSrc,
  tplStatusSrc,
  tlite
) => {
  tlite(el => el.className === "partly-available");

  return Backbone.View.extend({
    template: tplEngine.compile(tpl),
    tplSelect: tplEngine.compile(tplSelectSrc),
    tplStatus: tplEngine.compile(tplStatusSrc),

    events: {
      "change #webProductType": "renderWebProducts",
      "change #webProductId": "renderWebProductInfo"
    },

    data: {},

    dates: {},

    webProductId: 0,

    /**
     *
     * @returns {exports.render}
     */
    render() {
      const me = this;

      // ////////////////////////////////////////
      // get possible initial data
      if (!this.data.type) {
        this.data.type = this.$el.data("product-type");
      }
      if (!this.data.id) {
        this.data.id = this.$el.data("product-id");
      }
      if (!this.data.quantity) {
        this.data.quantity = this.$el.data("quantity");
      }
      if (!this.data.date) {
        this.data.date = this.$el.data("date");
      }
      if (!this.data.showTypes) {
        this.data.showTypes = this.$el.data("show-types");
      }

      this.enableNavigation = this.$el.data("enable-navigation");

      // this.data = {
      //     'type': this.$el.data('product-type'),
      //     'id': this.$el.data('product-id'),
      //     'quantity': this.$el.data('quantity'),
      //     'date': this.$el.data('date'),
      //     'showTypes': this.$el.data('show-types')
      // };

      this.$el.html(this.template());

      if (this.data.showTypes === true) {
        this.renderWebProductTypes();
      }

      if (this.data.type) {
        this.renderWebProducts(this.data.type, this.data.id);
      }

      if (this.data.id) {
        this.renderWebProductInfo(this.data.id);
      }

      me.$el.on("_adjustDateByMonth", (/* event */) => {
        const $datepickerGroups = me.$el.find(".ui-datepicker-group");

        if ($datepickerGroups.length) {
          $datepickerGroups.each(function() {
            me.retrieveAvailabilityDates($(this));
          });
          return;
        }

        const $widget = me.$el.find(".datepicker.hasDatepicker .ui-widget");
        const $newDiv = $("<div class='ui-datepicker-group'></div>");
        $newDiv.append($widget.find(".ui-datepicker-header"));
        $newDiv.append($widget.find(".ui-datepicker-calendar"));
        $widget.append($newDiv);
        me.retrieveAvailabilityDates($newDiv);
      });

      return this;
    },

    /**
     *
     */
    renderWebProductTypes() {
      const $el = this.$el.find(".webProductType");
      this.renderSelect(
        $el,
        "/gateway/webProduct/type/",
        {},
        {
          id: -1,
          title: "Selecteer type arrangement"
        },
        this.data.type
      );
    },

    /**
     *
     * @param event
     */
    renderWebProducts(event) {
      const $el = this.$el.find(".webProductId");

      let type = event;
      if (event && event.currentTarget) {
        const $typeEl = $(event.currentTarget);
        type = parseInt($typeEl.val(), 10);

        if (this.enableNavigation) {
          router.navigate(type !== -1 ? `type/${type}` : "");

          document.title = document.title.replace(
            /Beschikbaarheid.* - /,
            `Beschikbaarheid ${$typeEl.find(":selected").text()} - `
          );
        }
      }

      if (type === -1) {
        $el.parents(".container:not(.siteContainer)").hide();
        return;
      }

      $el.parents(".container:not(.siteContainer)").show();

      this.data.type = type;

      this.renderSelect(
        $el,
        "/gateway/webProduct/",
        {
          type
        },
        {
          id: -1,
          title: "Selecteer arrangement"
        },
        this.data.id
      );
    },

    /**
     *
     * @param $el
     * @param url
     * @param params
     * @param defaultOption
     * @param defaultValue
     */
    renderSelect($el, url, params, defaultOption, defaultValue) {
      const me = this;

      $el.siblings(".container").hide();

      const $select = $el.show().find("select");

      this.doVisibleXhr($el, "get", url, params || {}).then(result => {
        $select
          .html(
            me.tplSelect({
              defaultOption,
              current: defaultValue,
              items: result
            })
          )
          .trigger("change");
      });
    },

    /**
     *
     * @param event
     */
    renderWebProductInfo(event) {
      const $select = this.$el.find(".webProductId");

      const $el = $select.siblings(".container");

      let quantity = 0;
      let id = event;

      if (event && event.currentTarget) {
        id = parseInt($(event.currentTarget).val(), 10);
        quantity = parseInt(
          $(event.currentTarget)
            .find("option:selected")
            .data("quantity"),
          10
        );
      }

      if (id === -1) {
        $el.hide();
        this.dates = {};
        this.$el.find(".datepicker").datepicker("destroy");
        this.renderStatus();
        return;
      }

      if (id !== this.data.id) {
        this.renderStatus();
      }
      this.data.id = id;

      if (this.enableNavigation) {
        router.navigate(`type/${this.data.type}/${this.data.id}`);

        document.title = document.title.replace(
          /Beschikbaarheid.* - /,
          `Beschikbaarheid ${$select.find(":selected").text()} - `
        );
      }

      const $quantity = $el.show().find("#quantity");
      const val = $quantity.attr("min", quantity).val();
      if (!val || val <= 0 || val < quantity) {
        $quantity.val(quantity);
      }
      $quantity
        .next()
        .find(".minimumQuantity")
        .html(quantity);

      this.renderDatePicker(this.data.date);

      this.$el.trigger("_adjustDateByMonth");
    },

    /**
     *
     */
    renderDatePicker(dateText) {
      const me = this;

      const today = new Date();
      let startDate = today;
      if (dateText) {
        startDate = $.datepicker.parseDate("dd-mm-yy", dateText);
      }
      startDate.setUTCHours(12, 0, 0, 0);
      startDate.setUTCMinutes(0);
      startDate.setUTCSeconds(0);

      // var $quantity = me.$el.find('#quantity');
      const $datepicker = me.$el.find(".datepicker");

      $datepicker.datepicker("destroy");
      $datepicker.datepicker({
        altField: ".datepicker-alternate",
        altFormat: "dd-mm-yy",
        showWeek: true,
        numberOfMonths: window.innerWidth >= 768 ? 3 : 1,
        firstDay: 1,
        defaultDate: startDate,
        onSelect: me.renderStatus.bind(me),
        beforeShowDay(_date) {
          if (Object.keys(me.dates).length === 0) {
            return [false];
          }

          const dateString = $.datepicker.formatDate("dd-mm-yy", _date);
          if (typeof me.dates[dateString] === "undefined") {
            return [false];
          }

          let bookedRooms = me.dates[dateString];

          if (bookedRooms >= 28) {
            bookedRooms = -1;
          }

          if (bookedRooms >= 0) {
            const roomsLeft = 28 - bookedRooms;
            const hasRoomsLeft = bookedRooms === 0; // (26 - bookedRooms - $quantity.val()) > 0;
            return [
              true,
              `acal-day ${hasRoomsLeft ? "available" : "partly-available"}`,
              hasRoomsLeft
                ? "Beschikbaar"
                : `Reserveer snel! Nog maar ${
                  roomsLeft < 0 ? 0 : roomsLeft
                } plekken beschikbaar.`
            ];
          }

          if (bookedRooms === -2) {
            return [
              false,
              "acal-day not-available-option",
              "Niet beschikbaar wegens optie"
            ];
          }

          return [false, "acal-day not-available", "Niet beschikbaar"];
        }
      });

      if (dateText) {
        me.$el.find(".datepicker").datepicker("setDate", startDate);
        $.datepicker._selectDate(me.$el.find(".datepicker")[0]);
      }

      tlite(el => el.className.indexOf("acal-day") !== -1);
    },

    /**
     *
     * @param $calendar
     */
    retrieveAvailabilityDates($calendar) {
      const me = this;

      const id = this.$el
        .find(".webProductId")
        .find("select")
        .val();
      if (id === -1) {
        return;
      }

      const data = {
        id,
        year: $calendar.find(".ui-datepicker-year").text(),
        month:
          $.datepicker.regional.nl.monthNames.indexOf(
            $calendar.find(".ui-datepicker-month").text()
          ) + 1
      };

      // we re-find the element here as it has possibly been redrawn... (so no longer attached)!
      $calendar = me.$el.find(`.${$calendar.attr("class").replace(" ", ".")}`);

      this.doVisibleXhr(
        $calendar,
        "get",
        "/gateway/webProduct/availability/",
        data
      ).then(result => {
        $.extend(me.dates, result);
        $.datepicker._refreshDatepicker(me.$el.find(".datepicker")[0]);
      });
    },

    /**
     * Retrieves a XHR while also first setting an element to alpha 0.5 and on response back to alpha 1.
     *
     * @param $el
     * @param type
     * @param url
     * @param params
     * @returns {*}
     */
    doVisibleXhr($el, type, url, params) {
      $el.css("opacity", "0.5"); // .css('filter', 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0.5)');
      // $el.append('<span class="xhr-loader fa fa-circle-o-notch fa-spin"/>');

      return util.getCachedXhrPromise(type, url, params || {}).then(result => {
        $el.css("opacity", 1); // .css('filter', 'progid:DXImageTransform.Microsoft.Alpha(Opacity=1)');
        // $el.find('.xhr-loader').remove();
        return result;
      });
    },

    /**
     *
     */
    renderStatus(dateText /* , datepickerInstance */) {
      const me = this;

      if (!dateText || typeof this.dates[dateText] === "undefined") {
        this.$el.find(".status").html("");
        return;
      }

      let availability = this.dates[dateText];
      availability = availability > 0 ? 1 : availability;

      // -1 = niet beschikbaar
      //  0 = beschikbaar
      //  1 = deels beschikbaar

      let roomsLeft = 28 - this.dates[dateText];

      util
        .getCachedXhrPromise("get", "/gateway/webProduct/", {
          type: this.data.type
        })
        .then(result => result.filter(item => item.id === me.data.id).shift())
        .then(data => {
          if (!data) {
            return;
          }

          const dateEnd = moment(dateText, "DD-MM-YYYY")
            .add(data.duration, "m")
            .format("DD-MM-YYYY");

          if (dateText !== dateEnd) {
            dateText += ` t/m ${dateEnd}`;
          }

          me.$el.find(".status").html(
            me.tplStatus({
              arrangementTitle: me.$el
                .find(`option[value="${me.$el.find("#webProductId").val()}"]`)
                .text(),
              quantity: me.$el.find("#quantity").val(),
              availabilityStatus: availability,
              availabilityStatusString:
                availability === 0 ? "beschikbaar" : "deels beschikbaar",
              displayDate: dateText,
              roomsLeft: roomsLeft
            })
          );
        });
    }
  });
});
